// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","expertiseList":"_2WDrqHFqkFoe6ZSB-3mJOV"};